import {gql} from 'graphql-tag';

export const CREATE_STORE_LOCATOR_ITEM = gql`
  mutation createStoreLocatorItem($input: StoreLocatorItemCreateInput!) {
    createStoreLocatorItem(input: $input) {
      id
      settingsId
      clientId
      name
      address
      address2
      city
      state
      postalcode
      country
      phone
      tollfreephone
      fax
      websiteNectar
      websiteDC
      monopen
      monclose
      tueopen
      tueclose
      wedopen
      wedclose
      thuopen
      thuclose
      friopen
      friclose
      satopen
      satclose
      sunopen
      sunclose
      nectarBrand
      dreamCloud_Brand
      awaraBrand
      levelSleepBrand
      residentBrand
      sienaBrand
      nectarOriginal
      nectarLush
      nectarClassic
      nectarPremier
      nectarPremierCopper
      nectarClassicHybrid
      nectarPremierHybrid
      nectarPremierCopperHybrid
      nectarultra
      nectarultrahybrid
      adjustableBase
      theDreamCloud
      dreamCloudPremier
      dreamCloudPremierRest
      awara
      levelSleep
      siena
      sleepAccessories
      productCount_Nectar
      productCount_DC
      preferred_retailer
      best_selection
      ranking
      icon
      no1NectarRetailer
      mapIcon
      offerType
      shortSaleBanner
      saleBannerInStoreDetails
      topSeller
      pickupToday
      storeAppontment
      onSale
      storeAppontmentURL
      archived
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_STORE_LOCATOR_ITEM = gql`
  mutation updateStoreLocatorItem($id: ID!, $input: StoreLocatorItemUpdateInput!) {
    updateStoreLocatorItem(id: $id, input: $input) {
      id
      settingsId
      clientId
      name
      address
      address2
      city
      state
      postalcode
      country
      phone
      tollfreephone
      fax
      websiteNectar
      websiteDC
      monopen
      monclose
      tueopen
      tueclose
      wedopen
      wedclose
      thuopen
      thuclose
      friopen
      friclose
      satopen
      satclose
      sunopen
      sunclose
      nectarBrand
      dreamCloud_Brand
      awaraBrand
      levelSleepBrand
      residentBrand
      sienaBrand
      nectarOriginal
      nectarLush
      nectarClassic
      nectarPremier
      nectarPremierCopper
      nectarClassicHybrid
      nectarPremierHybrid
      nectarPremierCopperHybrid
      nectarultra
      nectarultrahybrid
      adjustableBase
      theDreamCloud
      dreamCloudPremier
      dreamCloudPremierRest
      awara
      levelSleep
      siena
      sleepAccessories
      productCount_Nectar
      productCount_DC
      preferred_retailer
      best_selection
      ranking
      icon
      no1NectarRetailer
      mapIcon
      offerType
      shortSaleBanner
      saleBannerInStoreDetails
      topSeller
      pickupToday
      storeAppontment
      onSale
      storeAppontmentURL
      archived
      createdAt
      updatedAt
    }
  }
`;

export const ARCHIVE_STORE_LOCATOR_ITEM = gql`
  mutation archiveStoreLocatorItem($id: ID!) {
    archiveStoreLocatorItem(id: $id) {
      id
      settingsId
      clientId
      name
      address
      address2
      city
      state
      postalcode
      country
      phone
      tollfreephone
      fax
      websiteNectar
      websiteDC
      monopen
      monclose
      tueopen
      tueclose
      wedopen
      wedclose
      thuopen
      thuclose
      friopen
      friclose
      satopen
      satclose
      sunopen
      sunclose
      nectarBrand
      dreamCloud_Brand
      awaraBrand
      levelSleepBrand
      residentBrand
      sienaBrand
      nectarOriginal
      nectarLush
      nectarClassic
      nectarPremier
      nectarPremierCopper
      nectarClassicHybrid
      nectarPremierHybrid
      nectarPremierCopperHybrid
      nectarultra
      nectarultrahybrid
      adjustableBase
      theDreamCloud
      dreamCloudPremier
      dreamCloudPremierRest
      awara
      levelSleep
      siena
      sleepAccessories
      productCount_Nectar
      productCount_DC
      preferred_retailer
      best_selection
      ranking
      icon
      no1NectarRetailer
      mapIcon
      offerType
      shortSaleBanner
      saleBannerInStoreDetails
      topSeller
      pickupToday
      storeAppontment
      onSale
      storeAppontmentURL
      archived
      createdAt
      updatedAt
    }
  }
`;

export const UNARCHIVE_STORE_LOCATOR_ITEM = gql`
  mutation unarchiveStoreLocatorItem($id: ID!) {
    unarchiveStoreLocatorItem(id: $id) {
      id
      settingsId
      clientId
      name
      address
      address2
      city
      state
      postalcode
      country
      phone
      tollfreephone
      fax
      websiteNectar
      websiteDC
      monopen
      monclose
      tueopen
      tueclose
      wedopen
      wedclose
      thuopen
      thuclose
      friopen
      friclose
      satopen
      satclose
      sunopen
      sunclose
      nectarBrand
      dreamCloud_Brand
      awaraBrand
      levelSleepBrand
      residentBrand
      sienaBrand
      nectarOriginal
      nectarLush
      nectarClassic
      nectarPremier
      nectarPremierCopper
      nectarClassicHybrid
      nectarPremierHybrid
      nectarPremierCopperHybrid
      nectarultra
      nectarultrahybrid
      adjustableBase
      theDreamCloud
      dreamCloudPremier
      dreamCloudPremierRest
      awara
      levelSleep
      siena
      sleepAccessories
      productCount_Nectar
      productCount_DC
      preferred_retailer
      best_selection
      ranking
      icon
      no1NectarRetailer
      mapIcon
      offerType
      shortSaleBanner
      saleBannerInStoreDetails
      topSeller
      pickupToday
      storeAppontment
      onSale
      storeAppontmentURL
      archived
      createdAt
      updatedAt
    }
  }
`;